export default __webpack_public_path__ + "static/air-defence-min-ee72518d8eee35c94a46b8309a790875.png";